// apps/patient/src/utils/subscriptionPoll.ts
//
// After Stripe Checkout redirects back, the subscription is granted by the stripe/main-webhook,
// which usually lands within a second or two. Poll /auth/me until exercise_app.subscription_status
// shows access, or give up after the configured attempts.

import { patientApiService } from '../services/api';

export const ONBOARDING_FORM_BACKUP_KEY = 'onboarding_form_backup';

const GRANTED_STATUSES = ['trial', 'active'];

export function exerciseSubscriptionGranted(profile: any): boolean {
  return GRANTED_STATUSES.includes(profile?.exercise_app?.subscription_status);
}

export async function waitForExerciseSubscription(
  options: { attempts?: number; intervalMs?: number } = {}
): Promise<any | null> {
  const attempts = options.attempts ?? 15;
  const intervalMs = options.intervalMs ?? 2000;

  for (let i = 0; i < attempts; i++) {
    try {
      const profile = await patientApiService.getMe();
      if (exerciseSubscriptionGranted(profile)) return profile;
    } catch (err) {
      console.warn('[subscriptionPoll] getMe failed, retrying', err);
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return null;
}
